"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from "@/components/ui/accordion";
import { PostsProvider, usePosts } from "@/integrations/wordpress/WordPressPostsProvider";
import { WP_Query } from "@/integrations/wordpress/wp_query";
const jitterStyle = `
  @keyframes underlineDraw {
    0% { background-size: 0% 2px; }
    100% { background-size: 100% 2px; }
  }
  .hover-draw:hover .title-text {
    background-image: linear-gradient(var(--primary), var(--primary));
    background-position: 0% 100%;
    background-repeat: no-repeat;
    animation: underlineDraw 0.3s ease forwards;
  }
`;
function NewsConsumer() {
  const {
    posts,
    loading,
    error
  } = usePosts();
  if (loading) {
    return <div data-section-id="223459" className="space-y-4">
        {[...Array(3)].map((_, i) => <div key={i} data-index={i} className="h-16 border border-border/30 bg-card/20 animate-pulse flex items-center px-4">
            <span className="text-muted-foreground text-sm font-mono">
              LOADING ARCHIVES...
            </span>
          </div>)}
      </div>;
  }
  if (error) {
    return <div className="p-4 border border-destructive/50 bg-destructive/10 text-destructive text-sm font-mono">
        ERROR: UNABLE TO RETRIEVE COMMENTARY
      </div>;
  }
  if (!posts || posts.length === 0) {
    return <div className="p-4 border border-border/30 text-muted-foreground text-sm font-mono">
        NO RECENT ENTRIES FOUND
      </div>;
  }
  return <Accordion type="single" collapsible className="w-full space-y-2">
      {posts.map((post, i) => {
      const formattedDate = post.date ? new Date(post.date).toLocaleDateString('en-US', {
        day: '2-digit',
        month: 'short',
        year: 'numeric'
      }) : "N/A";
      return <AccordionItem key={post.id} value={post.id} data-index={i} className="border-b border-border/50 bg-transparent data-[state=open]:bg-accent/30 transition-colors rounded-none">
            <AccordionTrigger className="px-0 py-8 hover:no-underline group hover-draw">
              <div className="flex items-center gap-4 text-left w-full pr-4">
                <span className="text-muted-foreground font-mono text-xs md:text-sm shrink-0 w-24">
                  {formattedDate}
                </span>
                <span className="font-default font-medium text-lg md:text-xl text-foreground title-text">
                  {post.title}
                </span>
              </div>
            </AccordionTrigger>
            <AccordionContent className="px-0 pb-8 pt-2 bg-transparent">
              <div className="text-muted-foreground font-default text-base leading-relaxed mb-8 pl-28" dangerouslySetInnerHTML={{
            __html: post.excerpt || "Full analysis pending publication..."
          }} />
              {post.link && <div className="pl-28">
                  <Link to={post.link}>
                    <Button variant="ghost" size="sm" className="font-default text-sm font-semibold text-primary hover:text-primary/80 hover:bg-transparent p-0 rounded-sm">
                      READ FULL ANALYSIS →
                    </Button>
                  </Link>
                </div>}
            </AccordionContent>
          </AccordionItem>;
    })}
    </Accordion>;
}
export default function DernieresNouvellesDuSysteme() {
  const wp_query_params = {
    post_type: "post"
  };
  const wp_query = new WP_Query(wp_query_params);
  return <section id="latest-blog-posts" className="bg-background text-foreground py-24 px-4 md:px-8 font-default border-y border-border/10 relative overflow-hidden">
      <style>{jitterStyle}</style>
      
      {}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,transparent_0%,var(--background)_100%)] pointer-events-none" />

      <div className="max-w-5xl mx-auto relative z-10">
        <div className="mb-12 border-b border-border/20 pb-6 flex flex-col md:flex-row md:items-end justify-between gap-4">
          <div>
            <span className="text-primary font-mono text-xs tracking-widest mb-2 block uppercase">Citizen Advocates Network</span>
            <h2 className="text-3xl md:text-4xl font-default font-bold tracking-tight text-foreground">Publications and Commentary</h2>
          </div>
          
        </div>

        <PostsProvider wp_query={{
        post_type: "post"
      }}>
          <NewsConsumer />
        </PostsProvider>

        <div className="mt-12 flex justify-center">
          <Link to="#">
            
          </Link>
        </div>
      </div>
    </section>;
}